import React from "react";
import SvgIcn from "../../../data/IconCompo";
import PropTypes from "prop-types";

const CategorySelector = ({ categories, selectedCategory, onChange }) => {
  return (


      <div className="radio-group">
        {categories.map((category) => (
          <label
            key={category.value}
            className={`radio-option ${
              selectedCategory === category.value ? "selected" : ""
            }`}
          >
            <input
              type="radio"
              name="category"
              value={category.value}
              checked={selectedCategory === category.value}
              onChange={() => onChange(category.value)}
              style={{ display: "none" }}
            />
            <SvgIcn name={category.icon} />
            {/* <span>{category.label}</span> */}
          </label>
        ))}
      </div>
   
  );
};

CategorySelector.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedCategory: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CategorySelector;